import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import { Typography, withStyles } from "@material-ui/core";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { WBSStore } from "modules/WBS/WBSStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import MenuHeader from "./layouts/MenuHeader";
import ModelMapList from "modules/modelMap/components/layouts/ModelMapList";
import { ERowType, EWBSView } from "common/enums";

const Title = withStyles((theme) => ({
  root: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    backgroundColor: "#2E2D2F",
    color: theme.palette.primary.light,
    padding: "10px 18px",
    textTransform: "uppercase" as any,
    letterSpacing: "1px",
  },
}))(Typography);

@observer
class ModelMapLateralMenu extends React.Component {
  componentDidMount() {
    ModelMapStore.fetchModelMaps();
  }

  handleChangeCheck = (checkedAll: boolean) => {
    ModelMapStore.checkAllModelMaps(checkedAll);
  };

  handleOpenAddLayer = async (type) => {
    await ModelMapStore.fetchModelMapProperties(type);
    setTimeout(() => {
      ModelMapStore.openLayerCreateModelMap(type);
    }, 500);
  };

  handleDeleteModelMap = async () => {
    setTimeout(() => {
      ModelMapStore.deleteCheckedModelMaps();
    }, 500);
  };

  handleClickUpdateTakeOffIntoWBS = async () => {
    await ModelMapStore.updateCheckedModelMapsTakeOffIntoWBS();
  };

  handleChangeSearch = (searchValue: string) => {
    ModelMapStore.searchModelMaps(searchValue);
  };

  checkIsSaving(modelMap): boolean {
    const { savingTakeOffItems } = TakeOffStore;

    let result = TakeOffStore.getIsSaving(savingTakeOffItems, modelMap);
    if (result) return result.isSaving;
    else return false;
  }

  checkIsValidSelectedRow(): boolean {
    const { selectedLine } = WBSStore;
    if (!selectedLine || selectedLine.index < 0 || !selectedLine.data)
      return false;

    const { rowType, fromModelMap, takeOffQuantity } = selectedLine.data;
    return Boolean(
      rowType !== ERowType.BLANK &&
        rowType !== ERowType.STAGE &&
        (!fromModelMap || takeOffQuantity)
    );
  }

  render() {
    if (!WBSStore.WBS.id) return <></>;

    const { modelMaps, modelMapCheck, modelMapsView } = ModelMapStore;
    const { tab, task, currentTab, selectedLine } = WBSStore;

    const takeOffIsNotLoading = TakeOffStore.statusModelmap !== "Loading";
    const tabIsEAP = tab === 0;
    const isEAPOpened =
      tabIsEAP &&
      !task &&
      currentTab === EWBSView.EAP &&
      selectedLine.index !== -1;

    return (
      <>
        <Title component="div">{i18n.modelMaps.menuLateral.modelMaps}</Title>
        <MenuHeader
          disabled={modelMaps === undefined || modelMaps.length === 0}
          checkedAll={
            modelMapCheck.length == modelMaps.length && modelMaps.length > 0
          }
          showDeleteButton={modelMapCheck.length > 0}
          showUpdateButton={ModelMapStore.modelMapsCheckedHasWarning()}
          onChangeSearch={this.handleChangeSearch}
          onChangeCheckAll={this.handleChangeCheck}
          onClickCreate={this.handleOpenAddLayer}
          onConfirmDeleteSelected={this.handleDeleteModelMap}
          onClickUpdateSelected={() => this.handleClickUpdateTakeOffIntoWBS()}
        />
        <ModelMapList
          modelMaps={modelMaps}
          modelMapsView={modelMapsView.map((mm) => {
            const takeOff = TakeOffStore.takeOffFormatedList.find(
              (i) => i.id == mm.id
            );
            const takeOffFormatedList = takeOff ? [...takeOff.data] : [];
            return {
              ...mm,
              saving: this.checkIsSaving(mm),
              checked: modelMapCheck.some((e) => e.id === mm.id),
              takeOffFormatedList,
            };
          })}
          showInsertQttButton={isEAPOpened && this.checkIsValidSelectedRow()}
          showInsertTakeOffButton={isEAPOpened}
          canEditName={takeOffIsNotLoading}
          showActionButton={takeOffIsNotLoading && tabIsEAP}
        />
      </>
    );
  }
}
export default ModelMapLateralMenu;



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/ModelMapLateralMenu.tsx